import {cn} from "../../../../../../lib/utils.ts";

interface VatLabelBadgeProps {
    label: string;
    size?: "sm" | "xs";
}

export function VatLabelBadge({label, size = "sm"}: VatLabelBadgeProps) {
    return (
        <span
            className={cn(
                "inline-flex items-center whitespace-nowrap rounded-md bg-white font-medium tabular-nums text-gray-800 ring-1 ring-inset ring-border",
                size === "sm" ? "px-2 py-0.5 text-xs" : "px-1.5 py-px text-[11px]",
            )}
        >
            {label}
        </span>
    );
}
